<template>
  <div class="panel" :style="{ '--scale-factor': scaleFactor }">
  <Header/>
    <div style="position: relative">
      <img
        src="@/assets/list/banners.png"
        style="width: 100%;height: 460px"
        alt=""
      />
      <div style="position: absolute;bottom: 12px;right:150px;color: #fffffd;cursor:pointer;">
        <span @click="$router.push({ path: '/' })">首页</span> /
        <span>{{ firstMenuName }}</span> /
        <span>{{menuName}}</span>
      </div>
    </div>
  <div
    id="list"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-text="处理中…… 请耐心等待"
    element-loading-spinner="el-icon-loading"
  >
    <div class="contentBox">
      <div class="left-nav" >
        <div class="titleNav">
          <div id="nav-body" style="width: 100%;">
            <div class="bg_title">
              <p style="color: #fff;font-size:32px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{ firstMenuName }}</p>
              <p style="color: #fff;font-size:12px;">LIST</p>
            </div>
            <sidebar-menu-item
              v-for="(item, i) in sidebarTree"
              :key="i"
              :item="item"
              :level="0"
              :active-id="menuId"
              @select="handleSidebarSelect"
            />

          </div>
        </div>
      </div>
      <div class="rightContent">
        <div class="box_card">
          <p
            v-show="linkAddress != ''"
            style="margin-top: 10px;"
          >
            <a :href="linkAddress">链接地址</a>
          </p>
          <el-card v-for="(c,i) in contentList" :key="i" :class="i==activeIndex?'active_card':'card_data'" @click.native="toDetail(c,i)">
            <div class="card_flex">
              <div class="left_box">
                <p style="height: 50px;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          display: -webkit-box;
                          -webkit-line-clamp: 2;font-family: MicrosoftYaHei-Bold;
font-weight: 700;
font-size: 18px;
color: #333333;
letter-spacing: 0;
                    " class="title">{{c.title}}</p>
                <p class="titleTime">{{c.addDate.substr(0,11)}}</p>
              </div >
              <div class="right_box">
                <img @error="handleImageError" :src="c.picUrl?'/mainsys/UserFiles/menupic/'+c.picUrl:defaultImg" alt="">
              </div>
            </div>
          </el-card>

        </div>

        <div v-if="total>0" style="margin-bottom: 20px">
          <el-pagination
            style="text-align: center;margin-top: 10px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 40, 50, 60]"
            :page-size="length"
            layout="total, sizes, jumper, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>

      </div>
    </div>
  </div>
    <!-- 底部快捷链接 -->
    <div class="bottomLink">
      <div style="
            margin: 0 auto;display: flex;
            align-items: center;
            justify-content: center;
            width: 1300px;
            padding: 0 5%;
            height: 60px;
">
        <div
          v-for="(item, index) in friendshipLink.res"
          :key="index"
          class="bottomLinkList"
          :style="{cursor:item.linkName == '中心服务'?'default':'pointer'}"
          @click="goLink(item)"
        >
          <div style="display:flex;align-items: center;">
            <img
              :src="'/mainsys/UserFiles/externalicon/' + item.linkImage"
              style="height: 18px;width: 18px;margin-right:12px;"
            />
            <div style="line-height: 20px;height: 20px;">
              {{ item.linkName }}
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- 底部版权信息 -->
    <div class="copyDiv">
      <div style="width: 100%;margin: 0 auto;display: flex;
          justify-content: space-between;
          align-items: center;">
        <div class="copyDivLeft">
          <img
            :src="require('../assets/bottomLogo.png')"
            alt=""
            style="width:360px;height:50px;margin-bottom:16px"
          />
          <div class="copyDivLeftCon">建设单位：国防科技大学</div>
          <div class="copyDivLeftCon">支持单位：湖南强智科技发展有限公司</div>
          <div class="copyDivLeftCon">
            推荐使用: Chrome或Firefox等主流浏览器
          </div>
          <div class="copyDivLeftCon">
            Copyright © 1999- 2024 国防科技大学 版权所有
          </div>
          <div class="copyDivLeftCon">
            总计访问次数：{{websiteVisitsNum}} 次 <span style="margin-left: 50px">年度访问次数：{{yearCount}} 次</span>
          </div>
        </div>
        <div
          class="copyDivRight"
          style="text-align:center;width: 140px"
          v-if="friendshipLink.top && friendshipLink.top.length > 0"
        >
          <img
            @error="handleImageError"
            :src="
              '/mainsys/UserFiles/externalicon/' +
                friendshipLink.top[0].linkImage
            "
            alt=""
            style="height:140px;margin:0 auto;text-align: center"
          />
          <div style="font-size: 16px;color: #FAFAFA;margin-top: 16px">
            {{ friendshipLink.top[0].linkName }}
          </div>
        </div>
      </div>

    </div>
</div>

</template>

<script>
//引入vuex附属函数
import { mapGetters } from "vuex";
import defaultImg from "@/assets/2.png"
import Header from "@/views/Header.vue";
import SidebarMenuItem from "@/components/SidebarMenuItem.vue";
export default {
  name: "list",
  data() {
    return {
      fullscreenLoading: false,
      menuId: this.$route.params.menuId,
      firstMenuName: "",
      firstMenuId: "",
      menuList: [],
      contentList: [],
      total: 0, //总页数
      page: 1, //页码
      length: 10, //长度
      linkAddress: "", //链接地址
      defaultImg:defaultImg,
      activeIndex:0,//默认选中样式
      menuName:"",
      websiteVisitsNum:0,
      yearCount:0,
      scaleFactor: 1, // 初始缩放比例
    };
  },
  components: {
    Header,
    SidebarMenuItem,
  },
  watch:{
    $route(newVal,oldVal){
      if(newVal.params.menuId){
        this.menuId = newVal.params.menuId;
        this.getSecondList();
      }
    },
  },
  computed: {
    ...mapGetters(["isMobile"]),
    // 从 Vuex navList 构建完整侧边栏树（text → label 归一化）
    sidebarTree() {
      return this.buildSidebarFromNavList(this.$store.state.navList, this.menuId)
    }
  },
  methods: {
    // 在树中递归查找菜单项
    findInTree(items, menuId) {
      for (const item of items) {
        if (String(item.id) === String(menuId)) return true
        if (item.children && item.children.length > 0) {
          if (this.findInTree(item.children, menuId)) return true
        }
      }
      return false
    },
    // 递归归一化 tree（将 text 映射为 label）
    normalizeTree(items) {
      return (items || []).map(item => ({
        ...item,
        label: item.label || item.text,
        children: item.children && item.children.length > 0 ? this.normalizeTree(item.children) : undefined
      }))
    },
    // 从 navList 提取当前菜单所属顶层父级的子级树
    buildSidebarFromNavList(navList, menuId) {
      if (!navList || !navList.length) return this.menuList || []
      for (const topItem of navList) {
        if (String(topItem.id) === String(menuId)) {
          // 当前就是顶层项 → 返回其子级
          return this.normalizeTree(topItem.children)
        }
        if (topItem.children && topItem.children.length > 0) {
          const found = this.findInTree(topItem.children, menuId)
          if (found) {
            // 当前菜单项属于该顶层 → 返回顶层子级树
            return this.normalizeTree(topItem.children)
          }
        }
      }
      // 兜底：用 API 返回的 menuList
      return this.menuList || []
    },
    handleImageError(e){
      e.target.src = require('../assets/2.png')
    },
    goLink(item) {
      if(item.linkName=='头歌'){
        this.$router.push({
          path: "/touGe",
          query: {url: item.linkUrl,activeIndex:null }
        });
      }else{
        if (item.linkUrl != "/") {
          if (item.linkTarget == "_blank") {
            window.open(item.linkUrl);
          } else {
            window.location.href = item.linkUrl;
          }
        }
      }

    },
    handleResize() {
      const windowWidth = window.innerWidth;
      const baseWidth = 1920; // 基准宽度
      console.log(windowWidth / baseWidth);
      this.scaleFactor = windowWidth / baseWidth
    },
    handleSidebarSelect(item) {
      this.$router.push({
        path: "List:menuId",
        name: "List",
        params: { menuId: item.id, label: item.label }
      });
    },

    toList(menuId, label) {
      this.$router.push({
        path: "List:menuId",
        name: "List",
        params: { menuId: menuId, label: label }
      });
    },
    // 每页条数变化
    handleSizeChange(val) {
      this.length = val;
      this.page = 1;
      this.getSecondList();
    },
    // 页码变化
    handleCurrentChange(val) {
      this.page = val;
      this.getSecondList();
    },
    getSecondList() {
      this.fullscreenLoading = true;
      let fd = new FormData();
      fd.append("page", this.page);
      fd.append("num", this.length);
      var choosedItem = {};
      // console.log("this.firstMenuName", this.firstMenuName);
      axios
        .post("/cmsapi/menus/" + this.$route.params.menuId, fd, {
          //顶部友情链接
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        })
        .then(response => {
          var recData = response.data;
          if (recData.secondMenu.length > 0) {
            recData.secondMenu.forEach((item, index) => {
              if (item.id == this.menuId) {
                choosedItem = item;
                this.linkAddress = item.href ? item.href : "";
              }
            });
          }

          this.total = recData.total;
          //在result里面还有个菜单路径，用的话在这里处理
          //self.menuList = result;
          this.firstMenuName = recData.firstMenuName;
          // 遍历recData.secondMenu 找出this.$route.params.menuId所在位置
          if (recData.secondMenu.length > 0) {
            recData.secondMenu.forEach((item, index) => {
              if (item.id == this.$route.params.menuId) {
                this.activeIndex = index;
              }
            });
          }
          if(recData.menuName){
            this.menuName=recData.menuName;
          }
          // console.log(this.$route.params)
          // console.log("this.firstMenuName", this.firstMenuName);
          // console.log(recData,'data\\')
          this.firstMenuId = recData.menuId;
          this.contentList = recData.dataList;

          if (
            recData.menuName == "仪器预约记录" ||
            recData.menuName == "实验室预约记录" ||
            choosedItem.label == "使用记录" ||
            recData.menuName == "考勤记录" ||
            recData.menuName == "实验室信息" ||
            recData.menuName == "成绩查询" ||
            recData.menuName == "违规扣分处罚信息"
          ) {
            this.$router.push({
              path: "detail:contentId",
              name: "Detail",
              params: {
                contentId: this.contentList[0].id,
                label: recData.menuName
              }
            });
          } else if (this.total == 1) {
            this.$router.push({
              path: "detail:contentId",
              name: "Detail",
              params: {
                contentId: this.contentList[0].id,
                label: this.contentList[0].title
              }
            });
          }

          //如果只有一级菜单，就把一级菜单放上。
          if (recData.secondMenu.length == 0) {
            this.menuList = [
              {
                label: recData.firstMenuName,
                id: recData.menuId
              }
            ];
          } else {
            //多条列表
            this.menuList = recData.secondMenu;
            if (
              choosedItem.label == "仪器预约记录" ||
              choosedItem.label == "实验室预约记录" ||
              choosedItem.label == "使用记录" ||
              choosedItem.label == "考勤记录" ||
              choosedItem.label == "成绩查询" ||
              recData.menuName == "实验室信息" ||
              recData.menuName == "违规扣分处罚信息"
            ) {
              this.$router.push({
                path: "detail:contentId",
                name: "Detail",
                params: {
                  contentId: this.contentList[0].id,
                  label: choosedItem.label
                }
              });
            }
          }
          this.fullscreenLoading = false;
        })
        .catch(error => {
          this.fullscreenLoading = false;
        });


    },
    toDetail(row,index) {
      this.activeIndex = index;
      this.$router.push({
        path: "detail:contentId",
        name: "Detail",
        params: { contentId: row.id, label: row.title }
      });
    },
    getAccessLogNum(){
      axios
        .post("/cmsapi/getAccessLogNum").then((res)=>{
        if(res.data.code == '2'){
          this.websiteVisitsNum = res.data.data
          this.yearCount=res.data.yearCount
        }
      })
    },
  },
  created() {
    console.log(this.$route.params,'xxxxxx')
  },
  mounted() {
    this.getAccessLogNum()
    if (this.$route.params.menuId) {
      this.menuId = this.$route.params.menuId;
      this.getSecondList();
      this.$forceUpdate()
    }
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // 初始化时执行一次
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.menuId = this.$route.params.menuId;
    this.getSecondList();
  }
};
</script>
<style scoped lang="less">
.contentBox{
  width: 100%;
  margin: 0 auto;
  padding: 50px 150px;
  display: flex;
  justify-content: space-between;
  min-height: 600px;
  .left-nav{
    width: 360px;
    position: relative;
    height: 600px;
    background: #f2f2f2 url("~@/assets/bg_bottom.png") no-repeat center bottom;
    background-size: contain;
    margin-right: 50px;
    .bg_title{
      width: 100%;
      height: 122px;
      background: url("~@/assets/list/bg1s.png") no-repeat;
      background-size: 100% 100%;
      padding: 25px 0 0 40px;
      margin-bottom: 16px;
    }
  }
  .rightContent{
    width: calc(100% - 410px);
    min-height: 300px;
    position: relative;
    .box_card{
      display: flex;
      justify-content: space-between;
      width: 100%;
      align-content: flex-start;
      flex-wrap: wrap;
      //min-height: 600px;
      padding: 5px;
      .card_data{
        width: 49%;
        height: 130px;
        margin-bottom: 20px;
        .card_flex{
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 90px;
          .left_box{
            width: calc(100% - 135px);
            height: 100%;
            position: relative;
            .titleTime{
              color: #a1a1a1;
              font-size: 14px;
              position: absolute;
              bottom: 0;
              left:0px;
            }
          }
          .right_box{
            width: 132px;
            height: 100%;
            img{
              width: 100%;
              height: 90px;
              object-fit: cover;
            }
          }
        }
      }
      .active_card{
        width: 49%;
        height: 130px;
        margin-bottom: 20px;
        //左边框
        border-left: #176DAA 6px solid;
        .card_flex{
          display: flex;
          align-items: center;
          justify-content: space-between;
          height:90px;
          .left_box{
            width: calc(100% - 135px);
            height: 100%;
            position: relative;
            .titleTime{
              color: #a1a1a1;
              font-size: 14px;
              position: absolute;
              bottom: 0;
              left:0px;
            }
          }
          .right_box{
            width:132px;
            height: 100%;
            img{
              width: 100%;
              height: 90px;
              object-fit: cover;
            }
          }
        }
        .title{
          color: #176DAA;
        }
      }
    }
  }
}



.titleNav{
  //position: absolute;
  //top: 0;
}
.activeBorder{
  //border-bottom: 1px solid rgba(223,227,232,1);
  font-size:20px;
  font-weight:700;
  color:rgba(128,128,128,1);
  cursor: pointer;
  border-left: 4px solid #176DAA;
  color: #176DAA;
  padding-left: 40px;
}
.hoverBorder{
  //border-bottom: 1px solid rgba(223,227,232,1);
  font-size:20px;
  font-weight:400;
  color:#333333;
  cursor: pointer;
  padding-left: 40px;
}

</style>
<style scoped>
.el-divider--horizontal{
  width: calc(100% - 80px);
  margin: 16px auto !important;
}
.panel{
  transform-origin: center;
  /* 确保子元素也按比例缩放 */
  width: calc(100% / var(--scale-factor));
  height: calc(100% / var(--scale-factor));
  transform: scale(var(--scale-factor));
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(var(--scale-factor));
}
.activeP{
  color: #176DAA;
}
.bottomLink {
  height: 60px;
  width: 100%;
  /* width: calc(100% - 520px); */
  background: #105C93;
  color: #fff;
}
.bottomLinkList {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 280px;
  position: relative;
}
.bottomLinkList:not(:last-child)::after {
  content: "";
  width: 1px;
  height: 24px;
  opacity: 0.2;
  background-color: #fff;
  position: absolute;
  right: 0;
}
.linkDivider >>> .el-divider--vertical {
  height: 24px !important;
  background-color: #3f6bae !important;
  width: 1.5px !important;
  margin: 0 30px 36px 30px !important;
}
.copyDiv {
  height: 300px;
  /* width: calc(100% - 520px); */
  padding: 40px 260px;
  background: url("../assets/bottomBgs.png") no-repeat;
  background-size: 100% 100%;
}
.copyDivLeftCon {
  opacity: 0.8;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  margin-top: 12px;
}
</style>
